import { Component, ViewChild } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { SalesAdminService } from 'src/app/assabil-sales/services/sales-admin-service';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { RoleProductQuota } from 'src/app/assabil-sales/models/entities/role-product-quota';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { LeanDataFormComponent } from 'src/app/tools/components/lean-data-form/lean-data-form.component';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
  
@Component({
  selector: 'role-product-quota',
  templateUrl: './role-product-quota.component.html',
  styleUrls: ['./role-product-quota.component.scss']
})

export class RoleProductQuotaComponent extends BasePage2<RoleProductQuota> {

  @ViewChild('leanDataForm', {static : false}) leanDataForm : LeanDataFormComponent;

  roleProductQuotas : RoleProductQuota[];

  rootRole          : Role; 
  selectedRole      : Role; 
  roleCode          : string;

  entryMode         : boolean = true;
  enteredOnly       : boolean = false;

  roles             : Role[] = [];
  rateVisible       : boolean = true;

  constructor(
    protected toastr            : ToastrService,
    protected router            : Router,
    protected salesAdminService : SalesAdminService,
    public    masterDataService : MasterDataService,
    protected baseService       : BaseService,
    protected leanUtilsService  : LeanUtilsService, 
    protected location          : Location) { 
       super(toastr, router, baseService, leanUtilsService, location); 
  }


  //----------------------------------------------------------------------
  ngOnInit(){
    
    super.ngOnInit();

    this.init();

    this.masterDataService.personRoleGet('sales').then(result => {
      this.rootRole = result;
    })

  }
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------
  init(){
    this.masterDataService.loadProductPages(4, false).then(res => {});
  }

  //----------------------------------------------------------------------
  

  //----------------------------------------------------------------------
  ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  //----------------------------------------------------------------------
  

  //----------------------------------------------------------------------
  getRows() : any {
      throw new Error("Method not implemented.");
    }
  //----------------------------------------------------------------------

  
  
  //----------------------------------------------------------------------
  loadData() {
    this.salesAdminService.roleProductQuotasGet(this.roleCode, false).then(roleProductQuotas => {
      this.setRolesAndProductQuotas(roleProductQuotas);
      this.salesAdminService.roleProductQuotasGet(this.roleCode, true).then(roleProductQuotas => {
        this.setMaxquantities(roleProductQuotas);
      })
    })
  }
  //----------------------------------------------------------------------


  //----------------------------------------------------------------------
  validate(){
    let roleProductQuotas : RoleProductQuota[] = [];

    for (let pp of this.masterDataService.salableProductPages) {
      for (let product of pp.products) {

        let relevantProduct = false;
        for (let i= 0; i< this.roles.length; i++){
          if (product.quantityP[i] || product.quantityU[i]) {
            relevantProduct = true;
            break;
          }
        }
        if (! relevantProduct) continue;

        for (let i= 0; i< this.roles.length; i++){
            let roleProductQuota : RoleProductQuota = new RoleProductQuota();
            roleProductQuota.product             = new Product();
            roleProductQuota.product.productCode = product.productCode;
            roleProductQuota.role                = new Role();
            roleProductQuota.role.roleCode       = this.roles[i].roleCode;
            roleProductQuota.assignedQuantity    = this.leanUtilsService.nullToZero(product.quantityP[i]) * product.loadPacking + this.leanUtilsService.nullToZero(product.quantityU[i]) ;
            roleProductQuotas.push(roleProductQuota);
        }
      }
    }

    this.salesAdminService.roleProductQuotasSave(this.roleCode, roleProductQuotas).then(roleProductQuotas => {
      this.setRolesAndProductQuotas(roleProductQuotas);
    });
  }
  //----------------------------------------------------------------------


  //----------------------------------------------------------------------
  setMaxquantities(roleProductQuotas : RoleProductQuota[]){
    for (let roleProductQuota of roleProductQuotas){
      if (! roleProductQuota.product) continue;
      let found = false;
      for (let pp of this.masterDataService.salableProductPages) {
        for (let product of pp.products) {
          if (product.productCode == roleProductQuota.product.productCode) {
            product.availableQuantity = roleProductQuota.assignedQuantity;
            found = true;
            break;
          }
        }
        if (found) break;
      }
    }
  }
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------
  setRolesAndProductQuotas(roleProductQuotas : RoleProductQuota[]){
    this.roleProductQuotas = roleProductQuotas;
    let currentRoleCode = null;
    this.roles = [];
    for (let roleProductQuota of this.roleProductQuotas){
      if (currentRoleCode != roleProductQuota.role.roleCode) {
        this.roles.push(roleProductQuota.role);
        currentRoleCode = roleProductQuota.role.roleCode;
      }
    }


    for (let pp of this.masterDataService.salableProductPages) {
      for (let product of pp.products) {
          product.rate = [];
          product.quantityP = [];
          product.quantityU = [];

      }
    }

    let index = -1;
    currentRoleCode = null;
    
    for (let roleProductQuota of this.roleProductQuotas){
      if (currentRoleCode != roleProductQuota.role.roleCode) {
        currentRoleCode = roleProductQuota.role.roleCode;
        index++;
      
      }

      if (! roleProductQuota.product) continue;

      for (let pp of this.masterDataService.salableProductPages) {
        let found = false;
        for (let product of pp.products) {
          if (product.productCode == roleProductQuota.product.productCode) {
            product.rate[index] = roleProductQuota.rate;
            product.quantityP[index] = Math.floor(roleProductQuota.assignedQuantity / product.loadPacking);
            product.quantityU[index] = roleProductQuota.assignedQuantity % product.loadPacking;            
            found = true;
            break;
          }
        }
        if (found) break;
      }
    }
  }
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------
  selectRoleAndGo(role : Role){ 
    this.selectRole(role);
    this.leanDataForm.hideFilter();
    this.loadData();
  }
  selectRole(role : Role){
    if (this.selectedRole != null) this.selectedRole.selected = false;
    this.selectedRole = role;
    this.selectedRole.selected=true;
    this.roleCode = this.selectedRole.roleCode;
  }
  //----------------------------------------------------------------------
  

  //----------------------------------------------------------------------
  getTotalQuantity(product : Product) : string{
    let totalUtnits = 0;
    for (let i= 0; i< product.quantityU.length; i++){
      if (product.quantityU[i]){
        totalUtnits += product.quantityU[i];
      }
    }

    let totalPacks = 0;
    for (let i= 0; i< product.quantityP.length; i++){
      if (product.quantityP[i]){
        totalPacks += product.quantityP[i];
      }
    }
    totalUtnits += totalPacks * product.loadPacking;

    product.totalQuantity = totalUtnits;
   
    let packs = Math.floor(totalUtnits / product.loadPacking);
    let units = totalUtnits % product.loadPacking;
   
    let res : string = "";
    res = packs + "";
    if (units) res += "  + " + units + "u";
    return res;
  }

  getMaxQuantity(product : Product): string{ 
    let res : string = "";
    if (!product.availableQuantity) product.availableQuantity = 0;
    let packs = Math.floor(product.availableQuantity / product.loadPacking);
    let units = product.availableQuantity % product.loadPacking;
    res = packs + "";
    if (units) res += "  + " + units + "u";
    return res;
  }
  //----------------------------------------------------------------------
  

  //----------------------------------------------------------------------
  dispatch(){
    for (let pp of this.masterDataService.salableProductPages) {
      for (let product of pp.products) {
        if (! product.availableQuantity) {
          for (let i= 0; i< this.roles.length; i++){
            product.quantityP[i] = null;
            product.quantityU[i] = null;
          }
        } else {
          for (let i= 0; i< this.roles.length; i++){
            let quantity =  Math.floor((product.availableQuantity * product.rate[i]) / 100);
            product.quantityP[i] = Math.floor(quantity / product.loadPacking);
            product.quantityU[i] = quantity % product.loadPacking;     
          }
        }
      }
    }
  }
  //----------------------------------------------------------------------

  hierarchycalDispatch(){
    this.salesAdminService.roleProductQuotasDispatch(this.roleCode).then(roleProductQuotas => {
      this.setRolesAndProductQuotas(roleProductQuotas);
    });
  }
}
